import {addons} from '@storybook/manager-api'
import theme from '../src/theme'

addons.setConfig({
  theme,
})
